module.exports = __webpack_public_path__ + "static/Footpad_v1-a34d193ff0009fdac1d1a59803db182d.png";